import CookiesJS from 'cookies-js';

/**
 * Варианты замены подгружаются при открытии окна.
 *
 * Раньше окно наполнялось полем similarRecipes — списком, который
 * заполняют руками в админке. Он пустой у всех рецептов, поэтому
 * замена не работала. Теперь список подбирается на лету и учитывает
 * приём пищи, вариант питания и исключённые продукты человека.
 */
export function initLoadReplacements($, apiClient) {
    const buttons = document.querySelectorAll('.replace__button');
    if (!buttons.length) return;

    let userPromise;
    const getUser = () => {
        if (!userPromise) userPromise = apiClient.getSelf(CookiesJS.get('auth_token'));
        return userPromise;
    };

    const loaded = new Set();

    function renderItem(recipe, originalRecipeId, programmId) {
        // На стенде у части рецептов фото нет — показываем заглушку,
        // чтобы карточки не разъезжались по высоте.
        const image = (recipe.imageHrefs && recipe.imageHrefs[0]) || '';
        // У заглушки своя пропорция, и если показывать её так же, как фото,
        // карточка вытягивается. Поэтому отдельный класс: рамка остаётся
        // квадратной, а рисунок вписывается в неё целиком.
        const coverClass = image ? 'live__cover' : 'live__cover live__cover--placeholder';
        // Подпись — время приготовления, как на карточках «Сегодня».
        const subTitle = recipe.time ? `${recipe.time} минут` : '';
        return `
            <div class="replace-option">
                <div class="live">
                    <div class="${coverClass}">
                        <img src="${image || '/img/recipe-placeholder.svg'}" alt="" decoding="async">
                    </div>
                    <h3 class="live__title">${recipe.title}</h3>
                    <p class="live__subtitle">${subTitle}</p>
                </div>
                <a href="#" class="replace-option__button action__replace-recipe"
                   data-programmId="${programmId}"
                   data-originalRecipeId="${originalRecipeId}"
                   data-recipeId="${recipe._id}">Выбрать</a>
            </div>`;
    }


    buttons.forEach(button => {
        button.addEventListener('click', async () => {
            const modalId = button.getAttribute('data-modalId');
            const modal = document.getElementById(modalId);
            if (!modal || loaded.has(modalId)) return;
            loaded.add(modalId);

            const recipeId = button.getAttribute('data-recipeId');
            const programmId = button.getAttribute('data-programmId');
            const mealTypes = button.getAttribute('data-mealTypes');
            const list = modal.querySelector('.replace__list');
            const loading = modal.querySelector('.replace__loading');
            const empty = modal.querySelector('.replace__empty');

            try {
                const user = await getUser();
                const recipes = await apiClient.getSimilarRecipes(
                    recipeId,
                    0.1,
                    CookiesJS.get('auth_token'),
                    {
                        mealTypes,
                        dietTypeCode: user && user.dietTypeCode,
                        excludeProductIds: (user && user.disallowedProducts) || [],
                    },
                );
                if (loading) loading.hidden = true;
                if (!recipes || !recipes.length) {
                    if (empty) empty.hidden = false;
                    // В макете у пустого состояния нет заголовка, и блок
                    // стоит по центру окна — остальное делают стили.
                    modal.classList.add('modal-replace--empty');
                    return;
                }
                // Простой список с прокруткой: карусель owl висит на
                // глобальном jQuery, а в сборке свой, и для трёх карточек
                // она всё равно не нужна.
                list.innerHTML = recipes
                    .map(recipe => renderItem(recipe, recipeId, programmId))
                    .join('');
            } catch (error) {
                // Окно не должно молчать: человек уже нажал кнопку.
                loaded.delete(modalId);
                if (loading) loading.textContent = 'Не удалось подобрать замены. Попробуйте позже.';
                console.error(error);
            }
        });
    });
}
